var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.27,
    height: 16.27,
    viewBox: "0 0 16.27 16.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8436",
    "data-name": "Rectangle 8436",
    width: 16.27,
    height: 16.27,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16106",
    "data-name": "Group 16106",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5877",
    "data-name": "Path 5877",
    d: "M15.99,6.317v6.19a3.771,3.771,0,0,1-3.762,3.762H3.762A3.771,3.771,0,0,1,0,12.508V4.041A3.771,3.771,0,0,1,3.762.279H9.97V2.018H3.762A2.033,2.033,0,0,0,1.737,4.041v8.467a2.033,2.033,0,0,0,2.025,2.025h8.466a2.033,2.033,0,0,0,2.025-2.025V6.318ZM9.433,9.264l6.336-6.336A1.716,1.716,0,0,0,13.341.5L6.76,7.082,6.7,7.209l-.367,2.5a.2.2,0,0,0,.224.221l2.517-.369c.1-.016.249-.194.356-.3Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksEdit);
export default __webpack_public_path__ + "static/media/tasks-edit.0976cb46d368b954bc6026bf324a8a5a.svg";
export { ForwardRef as ReactComponent };